export default "__VITE_ASSET__DVkElr86__"